module.exports = __webpack_public_path__ + "static/media/Anim_int.81b8777f.fbx";